import { createContext } from "react";
import openSocket from "socket.io-client";
// import config from "../../services/config";

const socketManager = {
	currentSocket: null,

	GetSocket: function () {
		const publicToken = localStorage.getItem("public-token");

		if (publicToken !== this.currentToken) {
			if (this.currentSocket) {
				this.currentSocket.disconnect();
			}

			this.currentToken = publicToken;
			this.currentSocket = openSocket(process.env.REACT_APP_BACKEND_URL, {
				transports: ["websocket", "polling"], // Fallback para polling
				pingTimeout: 60000,      // 60s - deve bater com backend
				pingInterval: 25000,     // 25s - deve bater com backend
				reconnection: true,      // Reconexão automática
				reconnectionDelay: 1000, // Aguardar 1s antes de reconectar
				reconnectionDelayMax: 5000, // Máximo 5s entre tentativas
				reconnectionAttempts: Infinity, // Tentar reconectar infinitamente
				timeout: 20000,          // 20s timeout para conexão
				query: publicToken ? { token: publicToken } : {},
				//auth: publicToken ? { token: publicToken } : {},
			});

			// Listeners de debug
			this.currentSocket.on("connect", () => {

			});

			this.currentSocket.on("disconnect", (reason) => {
				console.warn("❌ Socket desconectado:", reason);
				if (reason === "io server disconnect") {
					// Servidor forçou desconexão - reconectar manualmente
					this.currentSocket.connect();
				}
			});

			this.currentSocket.on("connect_error", (error) => {
				console.error("⚠️ Erro de conexão:", error.message);
			});

			this.currentSocket.on("reconnect", (attemptNumber) => {

			});

			this.currentSocket.on("reconnect_attempt", (attemptNumber) => {

			});

			this.currentSocket.on("reconnect_error", (error) => {
				console.error("❌ Erro ao reconectar:", error.message);
			});

			this.currentSocket.on("reconnect_failed", () => {
				console.error("💥 Falha total na reconexão");
			});

			// Listener para token expirado
			this.currentSocket.on("token:expired", (data) => {
				console.error("🔐 Token expirado:", data.message);
				// Limpar token e forçar re-login
				localStorage.removeItem("public-token");
				localStorage.removeItem("token");
				localStorage.removeItem("companyId");
				localStorage.removeItem("userId");
				// Redirecionar para login
				window.location.href = "/login";
			});
		}
		return this.currentSocket;
	},

	onConnect: function (callbackConnect) {
		if (this.currentSocket && this.currentSocket.connected) {
			callbackConnect();
		}
		this.currentSocket.on("connect", callbackConnect);
	},
};

const SocketContext = createContext()

export { SocketContext, socketManager };
